import { useModel as _useModel, defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7b50fcaf"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "user-login__item user-login__setpwd" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "user-login__sec" }, "设置登录密码", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "user-login__setpwd-info" }, " 由于您之前的账号未设置登录密码，您将无法使用密码登录 功能。请您设置登录密码后，您将可以使用密码登录功能。 ", -1))
const _hoisted_4 = { class: "user-login__setpwd-foot" }
const _hoisted_5 = { class: "user-login__setpwd-skip" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"line-height":"19px"} }, "设置", -1))

import { ref, defineModel } from 'vue';
import { BaseButton } from 'xrk-components';

import { LoginForm } from './login-base/index';
import type { FormRef } from '../types/index';
import { LoginTypeEnum, FormItemEnum } from '../constants/index';

import { setAPassword } from '../data-source/apis';
import { useSetup } from '../store';
import { useEnterpriseRealStoreSetup } from '@/views/enterprise-real/src/store/index';


export default /*#__PURE__*/_defineComponent({
  __name: 'login-setpwd',
  props: {
    "modelValue": {},
    "modelModifiers": {},
  },
  emits: ["update:modelValue"],
  setup(__props) {

const itemList = [FormItemEnum.pwd, FormItemEnum.pwd2, FormItemEnum.agreement];

const model = _useModel(__props, "modelValue");

// 表单实例
const formRef = ref<FormRef>(null);

const onCancel = () => {
  model.value = 'login-register';
};
// 跳过设置也算登录
const onSkip = async () => {
  await useSetup().login();

  const storeReal = useEnterpriseRealStoreSetup();
  storeReal.getEntpAuthInfo(data => {
    storeReal.skipNextPage(data.authStep, 'replace');
  });
};

const onLogin = async () => {
  await formRef.value.validate();
  await setAPassword({
    [FormItemEnum.pwd]: formRef.value.data[FormItemEnum.pwd],
    [FormItemEnum.pwd2]: formRef.value.data[FormItemEnum.pwd2],
    authentication: useSetup().info.authentication
  });
  await useSetup().login();
  model.value = 'login-success';
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _createVNode(_unref(LoginForm), {
      ref_key: "formRef",
      ref: formRef,
      itemList: itemList,
      pageType: _unref(LoginTypeEnum).SETPWD
    }, null, 8, ["pageType"]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_unref(BaseButton), {
        onClick: onCancel,
        type: "default"
      }, {
        default: _withCtx(() => [
          _createTextVNode("取消")
        ]),
        _: 1
      }),
      _createVNode(_unref(BaseButton), { click: onLogin }, {
        default: _withCtx(() => [
          _createTextVNode("提交")
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(_unref(BaseButton), {
        type: "text",
        click: onSkip
      }, {
        default: _withCtx(() => [
          _createTextVNode("跳过")
        ]),
        _: 1
      }),
      _hoisted_6
    ])
  ]))
}
}

})